// import {
//   Box
// } from "@mui/material";
// import { Outlet } from "react-router-dom";
// import SideNav from "../components/sideNav";
// import { useEffect } from "react";
// import Topbar from "../components/Topbar";
// function Layout() {



//   return (
//     <>
//       <Box sx={{ flexGrow: 1  }}>
//         <SideNav />
//         <Box >
//           <Topbar/>
//           <Outlet />
//         </Box>
//       </Box>
//     </>
//   );
// }

// export default Layout;






import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import SideNav from "../components/sideNav";
import Topbar from "../components/Topbar";
import ChatbotUI from "../view/agent/chatbot";


function Layout() {
  const { pathname } = useLocation();

  const HIDE_CHATBOT_ROUTES = ["/admin", "/login", "/settings" , "/super-admin"];

  const hideChatbot = HIDE_CHATBOT_ROUTES.some(route =>
    pathname.startsWith(route)
  );

  return (
    <Box sx={{ display: "flex", overflow: "hidden", width: "100vw" }}>
      <SideNav />
      <Box sx={{ flexGrow: 1, minWidth: 0, overflow: "hidden" }}>
        <Topbar />
        <Outlet />
        {!hideChatbot && <ChatbotUI />}
      </Box>
    </Box>
  );
}



export default Layout;


